import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
//import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MoreIcon from '@mui/icons-material/MoreVert';
import Avatar from '@mui/material/Avatar';
import Drawer2 from './Drawer2';
import InputBase from '@mui/material/InputBase';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  Snackbar,
  Alert,
  Button,
  TextField,
  Paper,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  ListItemButton,
  InputAdornment
} from '@mui/material';
import { Tooltip } from "@mui/material";
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { Bell } from 'lucide-react';
import { Crown } from 'lucide-react';
import { LogOut } from 'lucide-react';
import { Notyf } from 'notyf';

const notyf = new Notyf({
  position: { x: 'center', y: 'top' },
  duration: 3000,
});

const searchOptions = [
  { label: "Make Invoice", path: "/invoice" },
  { label: "Invoice Report", path: "/all-invoice" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "All Reports", path: "/allreport" },
  { label: "Add Expenses", path: "/expenses" },
  { label: "Expenses Report", path: "/report-expenses" },
  { label: "Add Product", path: "/production" },
  { label: "Add Item", path: "/items" },
  { label: "Add Return", path: "/return" },
  { label: "Add Investment", path: "/investment" },
  { label: "Inventory Details", path: "/inventory-details" },
  { label: "Charts", path: "/chart" },
  { label: "Add Customers", path: "/addcustomer" },
  { label: "Add Product", path: "/addproduct" },
  { label: "Add Expenses Category", path: "/addexpenses" },
  { label: "Add Suppliers", path: "/addsupplier" },
  { label: "My Profile", path: "/profile" },
  { label: "Balance Sheet", path: "/balancesheet" },
  { label: "Return Report", path: "/report-return-invoice" },
  { label: "Inventory Report", path: "/report-inventory" },
  { label: "Investment Report", path: "/report-investment" },
  { label: "Summary", path: "/report-summary" },
  { label: "Profit and Loss", path: "/report-profit-loss" },
  { label: "Customer Reports", path: "/report-customers" },
  { label: "Sales By Customer", path: "/report-sales-customer" },
  { label: "Sales By Product", path: "/report-sales-product" },
  { label: "Outstanding Report", path: "/eport-outstanding" },
];

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: 'auto',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

export default function PrimarySearchAppBar() {
  const [user, setUser] = useState({});
  const [token, setToken] = useState(() => localStorage.getItem('token') || null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [loading, setLoading] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const navigate = useNavigate();
  const [isBlack, setIsBlack] = useState(true); const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      const filtered = searchOptions.filter(option =>
        option.label.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions([]);
    }
  };

  const handleSelect = (path) => {
    navigate(path);
    setSearchTerm("");
    setFilteredOptions([]);
  };


  useEffect(() => {
    axios.get("https://admin.bizstor.lk/public/api/notifications")
      .then((res) => setNotifications(res.data))
      .catch((err) => console.error(err));
  }, []);

  const handleToggleChange = (event) => {
    setIsBlack(event.target.checked);
  };

  const bgColor = isBlack ? "black" : "#66615e";

  const handleSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  {/**useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    }
  }, [token]);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!token) return; // Exit if no token

      try {
        const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data);
      } catch (error) {
        console.log('');
      }
    };

    fetchProfile();
  }, [token]);*/}

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/"); // Redirect if no token
        return;
      }

      try {
        const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          navigate("/"); // Redirect on 401 error
        }
      }
    };

    fetchProfile();
  }, []);

  {/**const handleLogout = async () => {
    setLoading(true);
    try {
      await axios.post('https://admin.bizstor.lk/public/api/logout', null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      localStorage.removeItem('token');
      setToken('');
      handleSnackbar('Logout successfully!', 'success');
      setLoading(false);
      navigate('/');
    } catch (error) {
      handleSnackbar('Logout fail!', 'error');
      setLoading(false);
    }
  };*/}

  const handleLogout = async () => {
    setLoading(true);
    try {
      await axios.post("https://admin.bizstor.lk/public/api/logout", null, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      localStorage.removeItem("token");
      setToken(null);
      setLoading(false);
      notyf.success('Logout successfully!');
      navigate("/login");
    } catch (error) {
      notyf.error('Logout unsuccessfully! Try again.');
      setLoading(false);
    }
  };


  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleProfileRedirect = () => {
    navigate('/profile');
    handleMenuClose();
  };

  const handleHomeRedirect = () => {
    navigate('/dashboard');
  };

  const handleUpgrade = () => {
    navigate("/upgrade");
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{
        mt: 6
      }}
    >
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" p={3}>
        <Avatar
          alt={user.name}
          src={`https://admin.bizstor.lk/storage/app/public/images/${user.image}`} // Update the path to your image storage location
          sx={{ width: 100, height: 100, mb: 2 }}
        />
        <Typography variant="h6">{user.name}</Typography>
        {user.email !== 'bizstoradmin@gmail.com' && (

          <MenuItem onClick={handleProfileRedirect}>Profile</MenuItem>
        )}
        {/**<MenuItem onClick={handleLogout}><LogoutIcon /></MenuItem>*/}
      </Box>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const drawerVariants = {
    hidden: { opacity: 0, x: 30 },
    visible: { opacity: 1, x: 0, transition: { ease: "easeInOut", duration: 0.4 } },
    exit: { opacity: 0, x: 30, transition: { ease: "easeInOut", duration: 0.3 } },
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: '#FAFAFA', boxShadow: 'none' }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ color: 'black' }}
          >
            <Drawer2 />
          </IconButton>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              display: { xs: 'none', sm: 'block' },
              cursor: 'pointer',
              textTransform: 'uppercase',
              color: !user.companyname ? 'black' : 'black',
              fontWeight: 800,
              letterSpacing: 1,
              //fontStyle: 'italic'
            }}
            onClick={handleHomeRedirect}
          >
            {user.companyname ? user.companyname : 'Bizstor'}
          </Typography>




          <Box sx={{ flexGrow: 1 }} />
          {/** <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
          <FormControlLabel
          control={
            <Switch
              checked={isBlack}
              onChange={handleToggleChange}
              color="default"
            />
          }
        />
          </Box>*/}
          <Box
            sx={{
              mr: 1,
            }}
          >
            <TextField
              fullWidth
              placeholder="Search"
              variant="outlined"
              value={searchTerm}
              onChange={handleSearch}
              size="small"
              sx={{
                backgroundColor: "#e6e6e6ff",
                borderRadius: "25px",
                '& .MuiOutlinedInput-root': {
                  borderRadius: "25px",
                  '& fieldset': {
                    border: 'none', // removes the outline border
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: 'black', }} />
                  </InputAdornment>
                ),
              }}
            />

            {filteredOptions.length > 0 && (
              <Paper style={{ position: "absolute", width: { sm: '30%', xs: '100%', md: '30%' }, zIndex: 10 }}>
                <List>
                  {filteredOptions.map((option, index) => (
                    <ListItem key={index} disablePadding>
                      <ListItemButton onClick={() => handleSelect(option.path)}>
                        <ListItemText primary={option.label} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </Box>
          {/**<Tooltip title="Upgrade Plan" arrow>
            <Button
              onClick={handleUpgrade}
              sx={{
                width:'100px',
                height:'40px',
                borderRadius: '8px',
                background: "rgb(71, 71, 71)",
                color: "#fff",
                textTransform: "none",
                transition: 'all 0.3s ease',
                display: { sm: 'flex', xs: 'none' },
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                mr: 1,
                ml:1,
                gap:0.7,
                '&:hover': {
                  //filter: 'brightness(1.1)',
                  //transform: 'scale(1.1)',
                  //boxShadow: '0px 4px 12px rgba(0, 212, 255, 0.4)',
                  border:'2px solid rgb(71, 71, 71)',
                  borderRadius: '8px',
                },
                
              }}
            >
              <Crown size={20} /> <Typography variant='body'>Upgrade</Typography>
            </Button>
          </Tooltip>*/}

          <Tooltip title="Notification" arrow>
            <IconButton onClick={() => setOpen(true)}>
              <NotificationsIcon sx={{ color: 'black' }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Quick Logout" arrow>
            <IconButton onClick={handleLogout} sx={{ color: 'black' }} >
              <LogOut />
            </IconButton>
          </Tooltip>

          {/**<Tooltip title="Quick Logout" arrow>
            <MenuItem onClick={handleLogout} sx={{color:'black'}}><LogOut /></MenuItem>
          </Tooltip>*/}

          <Box sx={{ display: { xs: 'flex', md: 'flex' } }}>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <Avatar
                alt={user.name}
                src={`https://admin.bizstor.lk/storage/app/public/images/${user.image}`} // Update the path to your image storage location
              />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {loading && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'white',
          zIndex: 9999
        }}>
          <l-trio
            size="50"
            speed="1.3"
            color="red"
          ></l-trio>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{
            width: '100%',

          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={drawerVariants}
          style={{ width: 300, padding: 16 }}
        >
          <List>
            <ListItem>
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText primary="Notifications" />
            </ListItem>

            {notifications.length === 0 ? (
              <Box sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  No new notifications.
                </Typography>
              </Box>
            ) : (
              notifications.map((notification) => (
                <Box key={notification.id} sx={{ p: 2, mb: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
                  <Typography variant="h6">{notification.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {notification.message}
                  </Typography>
                </Box>
              ))
            )}
          </List>
        </motion.div>
      </Drawer>
    </Box>
  );
}
